module.exports = __webpack_public_path__ + "img/product2p.47a8591f.jpg";